module.exports = __webpack_public_path__ + "img/folder-create-fill.57ee075c.svg";